import { ITabData } from '../types';

export function mapClausesToTabs(clauses: HTMLElement[]) {
  if (clauses.length < 1) {
    return [];
  }

  return clauses
    .map((tabElement: HTMLElement) => {
      const [anchor, title = ''] = (tabElement.dataset.navTab || '/').split('/');

      return {
        title,
        anchor,
        point: tabElement.offsetTop,
      };
    })
    .filter((clause: ITabData) => Boolean(clause.title && clause.anchor))
    .sort((a, b) => a.point - b.point);
}
